import Badge from '@mui/material/Badge'
import styled from '@mui/material/styles/styled'

export const BadgeStyled = styled(Badge, { name: 'BadgeStyled' })`
  & .BaseBadge-badge {
    max-width: 20px;
  }
`
